import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

declare const process: { readonly env: Readonly<Record<string, string | undefined>> };

const REVIEW_ACCESS_CODE = process.env['REVIEW_ACCESS_CODE'];
const REVIEW_ACCESS_STORAGE_KEY = 'mon-testament.review-access-granted';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.review.html',
  styleUrl: './app.review.scss',
})
export class App {
  protected readonly reviewAccessCodeConfigured =
    typeof REVIEW_ACCESS_CODE === 'string' && REVIEW_ACCESS_CODE.length > 0;
  protected reviewAccessInput = '';
  protected reviewAccessError = false;
  protected reviewAccessGranted = this.readReviewAccessGrant();

  protected get reviewAccessBlocked(): boolean {
    return !this.reviewAccessGranted;
  }

  protected setReviewAccessInput(event: Event): void {
    this.reviewAccessInput = (event.target as HTMLInputElement).value;
    this.reviewAccessError = false;
  }

  protected submitReviewAccess(event: SubmitEvent): void {
    event.preventDefault();
    if (!this.reviewAccessCodeConfigured || REVIEW_ACCESS_CODE === undefined) {
      this.reviewAccessError = true;
      return;
    }
    if (this.reviewAccessInput !== REVIEW_ACCESS_CODE) {
      this.reviewAccessError = true;
      return;
    }
    try {
      globalThis.sessionStorage.setItem(REVIEW_ACCESS_STORAGE_KEY, 'granted');
    } catch {
      // The current app instance remains granted if sessionStorage is unavailable.
    }
    this.reviewAccessGranted = true;
    this.reviewAccessInput = '';
  }

  private readReviewAccessGrant(): boolean {
    if (!this.reviewAccessCodeConfigured) return false;
    try {
      return globalThis.sessionStorage.getItem(REVIEW_ACCESS_STORAGE_KEY) === 'granted';
    } catch {
      return false;
    }
  }
}
